<template>
  <div class="card organisation-card">
    <div class="organisation-head">
      <div>
        <div class="form-title">Mes 14 repas de la semaine</div>
        <p>Pour chaque déjeuner et dîner, je précise ce que je fais réellement.</p>
      </div>
      <div class="legend">
        <span>🍳 Je cuisine</span><span>🍽 Extérieur</span><span>♻ Restes</span>
      </div>
    </div>

    <div class="save-area">
      <span v-if="saveError" role="alert" class="organisation-save-error">{{ saveError }}</span>
      <span v-else-if="saveFeedback" role="status">{{ saveFeedback }}</span>
      <button type="button" class="button" :disabled="busy" @click="save">{{ busy ? "Enregistrement…" : "Enregistrer mes choix" }}</button>
      <button type="button" class="button" :disabled="busy" @click="saveAndRecalculate">Valider et mettre à jour ma semaine</button>
    </div>

    <div class="global-time">
      <div>
        <label>Mon temps maximum habituel pour cuisiner</label>
        <p>Ce temps s’applique à tous les repas que je cuisine.</p>
      </div>
      <select v-model="globalTime" @change="applyGlobalTime">
        <option value="max_30">30 min max</option>
        <option value="max_40">40 min max</option>
        <option value="max_50">50 min max</option>
        <option value="over_60">+ 1 heure</option>
      </select>
    </div>
    <label class="custom-time-toggle">
      <input type="checkbox" v-model="customTimes" />
      <span><strong>Je veux définir des temps différents selon les jours ou les repas</strong><small>J’ajuste alors individuellement le temps des repas que je cuisine.</small></span>
    </label>

    <div class="week-grid">
      <div v-for="day in days" :key="day.key" class="day-column">
        <div class="day-title">{{ day.label }}</div>
        <div v-for="meal in meals" :key="meal.key" class="meal-box">
          <div class="meal-title">{{ meal.label }}</div>
          <div class="mode-buttons">
            <button type="button" :class="{active:isCooking(day.key, meal.key)}" @click="setCooking(day.key, meal.key)">Je cuisine</button>
            <button type="button" :class="{active:value(day.key, meal.key)==='outside'}" @click="setValue(day.key, meal.key, 'outside')">Extérieur</button>
            <button type="button" :disabled="leftoversDisabled(day.key, meal.key)" :class="{active:value(day.key, meal.key)==='leftovers'}" @click="setValue(day.key, meal.key, 'leftovers')">Restes</button>
          </div>
          <select v-if="isCooking(day.key, meal.key) && customTimes" v-model="form[key(day.key, meal.key)]" class="time-select">
            <option value="max_30">30 min max</option>
            <option value="max_40">40 min max</option>
            <option value="max_50">50 min max</option>
            <option value="over_60">+ 1 heure</option>
          </select>
          <div v-if="!isCooking(day.key, meal.key)" class="mode-summary">{{ value(day.key, meal.key)==='outside' ? 'Repas pris à l’extérieur' : 'Restes du repas précédent' }}</div>
          <div v-else-if="!customTimes" class="mode-summary">{{ timeLabel(globalTime) }}</div>
        </div>
      </div>
    </div>

    <div class="save-area">
      <span v-if="saveError" role="alert" class="organisation-save-error">{{ saveError }}</span>
      <span v-else-if="saveFeedback" role="status">{{ saveFeedback }}</span>
      <button type="button" class="button" :disabled="busy" @click="save">{{ busy ? "Enregistrement…" : "Enregistrer mes choix" }}</button>
      <button type="button" class="button" :disabled="busy" @click="saveAndRecalculate">Valider et mettre à jour ma semaine</button>
    </div>

    <div class="organisation-footer">
      <div class="hint-text"><strong>Restes :</strong> disponibles uniquement si le repas précédent est cuisiné. L’analyse nutritionnelle reste basée sur les recettes cuisinées par Mes Meilleurs Menus.</div>

    </div>
  </div>
</template>

<script>
import { userState } from "@/utils/store";

export default {
  name: "PreparationTime",
  props: {busy: Boolean, saveFeedback: String, saveError: String},
  data() {
    return {
      saving: false,
      saved: false,
      globalTime: "max_40",
      customTimes: false,
      days: [
        {key:"monday",label:"Lundi"},{key:"tuesday",label:"Mardi"},{key:"wednesday",label:"Mercredi"},
        {key:"thursday",label:"Jeudi"},{key:"friday",label:"Vendredi"},{key:"saturday",label:"Samedi"},{key:"sunday",label:"Dimanche"}
      ],
      meals: [{key:"lunch",label:"Midi"},{key:"dinner",label:"Soir"}],
      form: {}
    };
  },
  computed: {
    preferences() { return userState.me?.consumer_account || {}; },
    orderedKeys() {
      const keys=[]; this.days.forEach(d=>this.meals.forEach(m=>keys.push(this.key(d.key,m.key)))); return keys;
    }
  },
  created() {
    const cookingTimes=[];
    this.days.forEach(d => this.meals.forEach(m => {
      const k=this.key(d.key,m.key);
      const val=this.preferences[k] || "max_40";
      this.$set(this.form,k,val);
      if(["max_30","max_40","max_50","over_60"].includes(val)) cookingTimes.push(val);
    }));
    if(cookingTimes.length) {
      this.globalTime=cookingTimes[0];
      this.customTimes=!cookingTimes.every(v=>v===cookingTimes[0]);
    }
  },
  mounted() { this.$emit("draft-change", {...this.form}); },
  watch: { form: {deep:true, handler(value) {this.$emit("draft-change", {...value});}} },
  methods: {
    key(day,meal){ return `meal_mode_${day}_${meal}`; },
    value(day,meal){ return this.form[this.key(day,meal)]; },
    isCooking(day,meal){ return ["max_30","max_40","max_50","over_60"].includes(this.value(day,meal)); },
    setCooking(day,meal){ if(!this.isCooking(day,meal)) this.$set(this.form,this.key(day,meal),this.globalTime); },
    applyGlobalTime(){
      if(this.customTimes) return;
      this.orderedKeys.forEach(k=>{ if(["max_30","max_40","max_50","over_60"].includes(this.form[k])) this.$set(this.form,k,this.globalTime); });
    },
    timeLabel(v){ return {max_30:"30 min max",max_40:"40 min max",max_50:"50 min max",over_60:"+ 1 heure"}[v] || "40 min max"; },
    setValue(day,meal,val){
      if(val==="leftovers" && this.leftoversDisabled(day,meal)) return;
      this.$set(this.form,this.key(day,meal),val);
      this.cleanInvalidLeftovers();
    },
    leftoversDisabled(day,meal){
      const k=this.key(day,meal), i=this.orderedKeys.indexOf(k);
      if(i<=0) return true;
      const prev=this.form[this.orderedKeys[i-1]];
      return prev==="outside" || prev==="leftovers";
    },
    cleanInvalidLeftovers(){
      this.orderedKeys.forEach((k,i)=>{
        if(this.form[k]!=="leftovers") return;
        if(i===0 || ["outside","leftovers"].includes(this.form[this.orderedKeys[i-1]])) this.$set(this.form,k,"max_40");
      });
    },
    saveAndRecalculate(){
      if(!this.customTimes) this.applyGlobalTime();
      this.cleanInvalidLeftovers();
      this.$emit("draft-change", {...this.form});
      this.$emit("recalculate-request");
    },
    save(){
      if(!this.customTimes) this.applyGlobalTime();
      this.cleanInvalidLeftovers();
      this.$emit("draft-change", {...this.form});
      this.$emit("save-request");
    }
  }
};
</script>

<style scoped>
.organisation-card{padding:20px;}
.organisation-head{display:flex;justify-content:space-between;gap:20px;align-items:flex-start;margin-bottom:16px;}
.organisation-head p{margin:4px 0 0;color:#65705f;}
.legend{display:flex;gap:12px;flex-wrap:wrap;font-size:12px;font-weight:700;color:#526348;}
.global-time{display:flex;justify-content:space-between;align-items:center;gap:20px;background:#f6f8f3;border:1px solid #e1e8d8;border-radius:12px;padding:14px 16px;margin-bottom:10px}.global-time label{font-weight:800;color:#315b19}.global-time p{margin:3px 0 0;color:#65705f;font-size:12px}.global-time select{min-width:150px;padding:9px;border:1px solid #dbe2d4;border-radius:8px;background:#fff}.custom-time-toggle{display:flex;align-items:flex-start;gap:9px;padding:10px 4px 15px;cursor:pointer}.custom-time-toggle input{margin-top:3px}.custom-time-toggle span{display:flex;flex-direction:column;gap:2px}.custom-time-toggle small{color:#65705f}
.week-grid{display:grid;grid-template-columns:repeat(7,minmax(135px,1fr));gap:8px;}
.day-column{min-width:0;background:#f6f8f3;border:1px solid #e1e8d8;border-radius:12px;padding:7px;}
.day-title{text-align:center;color:#315b19;font-weight:800;padding:5px 2px 9px;}
.meal-box{background:#fff;border:1px solid #e4e9df;border-radius:9px;padding:8px;margin-bottom:7px;}
.meal-title{font-size:11px;font-weight:800;text-transform:uppercase;color:#789b4a;margin-bottom:6px;}
.mode-buttons{display:grid;gap:4px;}
.mode-buttons button{border:1px solid #dbe2d4;border-radius:6px;background:#fff;color:#596452;padding:5px 4px;font-size:10px;font-weight:700;cursor:pointer;}
.mode-buttons button.active{background:#5f8435;border-color:#5f8435;color:#fff;}
.mode-buttons button:disabled{opacity:.35;cursor:not-allowed;}
.time-select{width:100%;margin-top:7px;padding:6px 4px;border:1px solid #dbe2d4;border-radius:6px;background:#f8faf5;font-size:11px;}
.mode-summary{margin-top:7px;min-height:28px;color:#65705f;font-size:10px;line-height:1.3;}
.organisation-footer{display:flex;justify-content:space-between;align-items:flex-end;gap:20px;margin-top:14px;}
.hint-text{max-width:700px;font-size:12px;color:#65705f;line-height:1.45;}
.save-area{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;gap:10px;margin:14px 0;flex:0 0 auto;}.organisation-save-error{color:#a03322;}
.saved{color:#3c6610;font-weight:700;font-size:12px;}
@media(max-width:1200px){.week-grid{grid-template-columns:repeat(4,1fr);}}
@media(max-width:760px){.week-grid{grid-template-columns:repeat(2,1fr)}.organisation-head,.organisation-footer{flex-direction:column;align-items:stretch}.save-area{justify-content:flex-end}}
@media(max-width:460px){.week-grid{grid-template-columns:1fr}}
</style>
